module.exports = __webpack_public_path__ + "6f8d4708f55ce5bf75e663ab5b561f99.svg";